/** Wide enough for issued-PDF history tables (declaration number + timestamps). */
export const declarationOfConformityGenerateDialogContentClassName =
  'max-h-[90vh] overflow-y-auto sm:max-w-4xl'
